document.querySelector('.pincode_check').addEventListener('click', function (event) {
  event.preventDefault(); // Prevent the form from submitting

  const pincodeInput = document.querySelector('input[name="pincode"]');
  const skuInput = document.querySelector('input[name="sku"]');
  const deliveryTimeElement = document.getElementById('delivery-time');

  // Validate pincode
  const pincode = pincodeInput.value.trim();
  if (pincode.length !== 6 || isNaN(pincode)) {
    deliveryTimeElement.textContent = "Please enter a valid 6-digit pincode.";
    return;
  }

  const sku = skuInput.value;

  // Calculate the estimated delivery date (add 3 days to current date)
  const currentDate = new Date();
  currentDate.setDate(currentDate.getDate() + 3);
  const options = { weekday: 'long', day: 'numeric', month: 'long' }; // Formatting options
  const formattedDateStart = currentDate.toLocaleDateString('en-US', options);
  currentDate.setDate(currentDate.getDate() + 2);

  // Update the delivery time in the DOM
  deliveryTimeElement.innerHTML = `Free Delivery by <strong>${formattedDateStart} to  ${currentDate.getDate()}.</strong>`;
});
